<template>
  <scout-form
    :is-modified="value !== null"
    :label="label"
    half
  >
    <select
      :value="valueToId"
      class="boss-input-select"
      @change="update($event.target.value)"
    >
      <option :value="null">
        指定なし
      </option>
      <option
        v-for="(option, i) in options"
        :key="i"
        :value="option.id"
      >
        {{ option.name }}
      </option>
    </select>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'

export default {
  components: {
    ScoutForm
  },
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'boolean' || prop === null
    },
    options: {
      required: true,
      type: Array
    },
    label: {
      required: true,
      type: String
    }
  },
  computed: {
    valueToId () {
      return this.value !== null ? Number(this.value) : null
    }
  },
  methods: {
    update (value) {
      this.$emit('input', value ? !!Number(value) : null)
    }
  }
}
</script>
